'use client'

import React, { memo } from 'react'
import { useNews } from '@/hooks/useNews'
import Link from 'next/link'
import TabCard from '../Cards/TabCard'

interface TabContentProps {
  slug: string
}

const TabContent: React.FC<TabContentProps> = ({ slug }) => {
  const { allNews, isLoading } = useNews({ menuSlug: slug })

  if (isLoading) {
    // Skeleton loading
    return (
      <div className="grid grid-cols-12 gap-4 pb-4 mb-5 animate-pulse">
        {/* Skeleton for the first large TabCard */}
        <div className="col-span-12 md:col-span-8 flex gap-4">
          <div className="w-1/3 h-[150px] bg-gray-300 rounded"></div>
          <div className="flex-1 space-y-3">
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            <div className="h-4 bg-gray-300 rounded w-full"></div>
            <div className="h-4 bg-gray-300 rounded w-5/6"></div>
            <div className="h-4 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>

        {/* Skeleton for the second smaller TabCard */}
        <div className="col-span-12 md:col-span-4 space-y-3">
          <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          <div className="h-4 bg-gray-300 rounded w-5/6"></div>
          <div className="h-4 bg-gray-300 rounded w-full"></div>
          <div className="h-4 bg-gray-300 rounded w-1/2"></div>
        </div>

        {/* Divider */}
        <div className="col-span-12">
          <div className="border-t border-gray-300"></div>
        </div>

        {/* Skeleton for the list of items */}
        <div className="col-span-12 grid grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <div className="h-3 bg-gray-300 rounded w-3/4"></div>
              <div className="h-3 bg-gray-300 rounded w-full"></div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (!allNews.length) {
    return <div>No news available</div>
  }

  return (
    <div className="grid grid-cols-12 gap-4 border-b border-gray-300 pb-4">
      {/* Bài đầu tiên (hình lớn) */}
      <div className="col-span-12 md:col-span-8">
        {allNews[0] && (
          <TabCard
            imageUrl={allNews[0]?.imageUrl}
            title={allNews[0]?.title}
            description={allNews[0]?.description}
            link={allNews[0]?.slug}
            isImage={true}
          />
        )}
      </div>

      {/* Bài thứ hai (không có hình) */}
      <div className="col-span-12 md:col-span-4">
        {allNews[1] && (
          <TabCard
            imageUrl={allNews[1]?.imageUrl}
            title={allNews[1]?.title}
            description={allNews[1]?.description}
            link={allNews[1]?.slug}
            isImage={false}
          />
        )}
      </div>
      {/* 8 bài tiếp theo (dạng danh sách) */}
      <div className="col-span-12">
        {allNews.slice(2, 10).length > 0 && (
          <div className="grid grid-cols-2 gap-4">
            {' '}
            {/* Sử dụng Grid với 2 cột */}
            {allNews.slice(2, 10).map((news) => (
              <div key={news.id} className="text-sm">
                <article className="inline" title={news.title}>
                  <Link
                    href={`/${news.slug}`}
                    className="text-black font-semibold hover:text-primary"
                  >
                    {news.title}
                  </Link>
                </article>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(TabContent)
